import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Layout from '../../components/UI/Layout/Layout';
import MoreComponent from '../../components/MoreComponent/MoreComponent';
import translation from '../../assets/data/LocalizedStrings/LocalizedStrings.json';

class MorePage extends Component {
  goBackHandler = () => {
    this.props.history.push('/');
  };

  render() {
    const {
      country,
      language,
      selectedUSA,
      selectedCanadaEN,
      selectedCanadaFR
    } = this.props;
    return (
      <Layout
        title={translation[language].moreInfo}
        clicked={this.goBackHandler}
        country={country}
        language={language}
        selectedCanadaEN={selectedCanadaEN}
        selectedCanadaFR={selectedCanadaFR}
        selectedUSA={selectedUSA}
      >
        <MoreComponent country={country}  language={language}/>
      </Layout>
    );
  }
}

MorePage.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  selectedCanadaEN: PropTypes.func,
  selectedCanadaFR: PropTypes.func,
  selectedUSA: PropTypes.func
};

export default withRouter(MorePage);
